export default {"src":"/_next/static/media/creditcard.005d6185.svg","height":430,"width":430,"blurWidth":0,"blurHeight":0};